import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Tooltip } from '@heroui/react';
import { ThemeTogglerButton } from './animate-ui/components/buttons/theme-toggler';
import { useTheme } from '../stores/theme-store';

const ThemeSwitcher: React.FC = () => {
  const { t } = useTranslation();
  const { resolvedTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return <div className="h-9 w-9" />;
  }

  const isDark = resolvedTheme === 'dark';

  return (
    <Tooltip
      content={t(isDark ? 'lightMode' : 'darkMode')}
      placement="bottom"
    >
      <div className="flex items-center">
        <ThemeTogglerButton />
      </div>
    </Tooltip>
  );
};

export default ThemeSwitcher;